import { render } from "./dash.vue?vue&type=template&id=02d2b7fc"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/dash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02d2b7fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02d2b7fc', __exports__)) {
    api.reload('02d2b7fc', __exports__)
  }
  
  module.hot.accept("./dash.vue?vue&type=template&id=02d2b7fc", () => {
    api.rerender('02d2b7fc', render)
  })

}


export default __exports__